module.exports = __webpack_public_path__ + "stylesheets/both-landings-common_87510a0221f4c268cfb0adedd99741c6.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/both-landings-common.less
// module id = vzSK
// module chunks = 151